document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".home-slider-swiper", {
    loop: true,
    effect: "fade",
    speed: 500,
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });
});
